
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trafficbox/contact-us",
      function () {
        return require("private-next-pages/trafficbox/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trafficbox/contact-us"])
      });
    }
  